module.exports = __webpack_public_path__ + "static/media/left.355fe77f.svg";